/**
 * The rates endpoint for checkout personalization assigns the treatment id if
 * it doesn't already know the assigned treatment id. To inform the rates
 * endpoint of the treatment id, we save the treatment id on a line item of the
 * cart as an attribute (since these are passed from Shopify to the rates
 * endpoint - likely not intentionally if I had to guess). This is the key for
 * that attribute.
 */
export const checkoutOptimizationTreatmentCacheId = "_redo_rco_t";
